import React from "react";
import useScreenOrientation from "./hooks/useScreenOrientation";
import WebPImage from "./WebPImage";

interface IOrientationWebpImgProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>{
  srcPortrait: string,
  srcLandscape: string,
  additionalClassName?: string,
  portraitHeight?: number,
  portraitWidth?: number,
  landscapeHeight?: number,
  landscapeWidth?: number,
}

export default function OrientationWebpImg({srcLandscape, srcPortrait, additionalClassName="", ...props}: IOrientationWebpImgProps ) {
  const orientation = useScreenOrientation();
  const isPortrait = orientation === "portrait"
  const src = isPortrait ? srcPortrait : srcLandscape;
  const height = isPortrait ? props.portraitHeight : props.landscapeHeight;
  const width = isPortrait ? props.portraitWidth : props.landscapeWidth;
  return (
    <WebPImage src={src} height={height} width={width} additionalClassName={additionalClassName} {...props}/>
  );
}